import ENDPOINTS from "../../constants/apiEndPoints";
import { axiosInstance } from "../axiosInstance";

// Get notifications (with pagination & type)
export const handleGetNotificationsService = async (
  params?: Record<string, any>
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_NOTIFICATIONS, {
    params,
  });
  return response?.data;
};

// Mark single notification as read
// export const handleMarkNotificationAsReadService = async (id: string) => {
//   const response = await axiosInstance.put(
//     ENDPOINTS.MARK_NOTIFICATION_AS_READ(id)
//   );
//   return response?.data;
// };

// Mark all notifications as read
export const handleMarkAllNotificationsAsReadService = async () => {
  const response = await axiosInstance.put(
    ENDPOINTS.MARK_ALL_NOTIFICATIONS_AS_READ
  );
  return response?.data;
};

// Delete single notification
export const handleDeleteNotificationService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.DELETE_NOTIFICATION(id)
  );
  return response?.data;
};

// Delete selected notifications
export const handleDeleteSelectedNotificationsService = async (
  notificationIds: string[],
) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.DELETE_SELECTED_NOTIFICATIONS,
    {
      data: { notificationIds },
    },
  );
  return response?.data;
};

// Delete all notifications
// export const handleDeleteAllNotificationsService = async () => {
//   const response = await axiosInstance.delete(
//     ENDPOINTS.DELETE_ALL_NOTIFICATIONS
//   );
//   return response?.data;
// };
